import React from 'react';
import {ReactComponent as LogoBrandmark} from "../assets/images/logo-new-brandmark.svg";
import Layout from "../components/common/Layout";
import ResetPasswordChangeForm from "../components/forms/ResetPasswordChangeForm";
import styles from "../styles/common/Login.module.scss";

function ResetPasswordChange() {
  return (
    <Layout
      pageTitle="Reset Password - Liquid Credit"
      hideHeader
      pageBodyClassName={styles.loginPage}
    >
      <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
          <div className={styles.logoIcon}>
            <LogoBrandmark />
          </div>
          <span className={styles.logoText}>Liquid Credit</span>
        </div>

        <div className={styles.loginCard}>
          <div className={styles.loginHeader}>
            <h2 className={styles.loginTitle}>
              Set New Password
            </h2>
            <p className={styles.loginSubtitle}>
              Enter your new password below
            </p>
          </div>

          <ResetPasswordChangeForm />
          
          <div className={styles.supportLink}>
            <span>Need help? </span>
            <a href="mailto:support@liquidcredit.co" className={styles.contactLink}>
              Contact Support
            </a>
          </div>
        </div>

        <div className={styles.securityNotice}>
        All transactions on Liquid Credit protected by enterprise-grade security.
        </div>
      </div>
    </Layout>
  );
}

export default ResetPasswordChange;